namespace $.$$ {
	type $shm_dashboard_admin_monitoring_record = $shm_pocketbase_record

	export class $shm_dashboard_admin_monitoring extends $.$shm_dashboard_admin_monitoring {
		tasks() {
			return this.$.$shm_pb.admin_records_all_realtime(
				'dashboard_file_update_tasks\n\n-created\nid,client,file,enabled,last_scheduled_at,last_success_at,last_message_at,last_daily_message_at,last_weekly_message_at,last_error,last_data_day,last_expected_data_day,last_date_status,ba_subscriber_id,ba_subscriber_daily_id,ba_subscriber_weekly_id,ba_subscriber_monthly_id',
			)
		}

		jobs() {
			return this.$.$shm_pb.admin_records_all_realtime(
				'dashboard_file_update_jobs\n\n-created\nid,task,period,status,stage,scheduled_for,started_at,mail_started_at,mail_finished_at,parse_started_at,parse_finished_at,duckdb_started_at,duckdb_finished_at,finished_at,emails_found,spam_found,attachments_found,rows_received,rows_added,reported_rows,count_status,message_at,error,data_day,expected_data_day,date_status,periods_found,duckdb_download_ms,duckdb_convert_ms,duckdb_open_ms,duckdb_read_ms,duckdb_insert_ms,duckdb_tags_ms,duckdb_fts_ms,duckdb_checkpoint_ms,duckdb_upload_ms,created',
			)
		}

		job_day( job: $shm_dashboard_admin_monitoring_record ) {
			const scheduled = String( job.scheduled_for || '' )
			const day = scheduled.match( /^\d{4}-\d{2}-\d{2}/ )?.[0]
			return day ?? String( job.created || '' ).slice( 0, 10 )
		}

		available_days() {
			return [ ... new Set( this.jobs().map( job => this.job_day( job ) ).filter( Boolean ) ) ].sort().reverse()
		}

		latest_day() {
			return this.available_days()[0] ?? new Date().toISOString().slice( 0, 10 )
		}

		day_display() { return this.date_only( this.day() ) }

		@ $mol_mem
		override day( next?: string ) {
			if( next !== undefined ) {
				const value = next.slice( 0, 10 )
				this.$.$mol_state_arg.value( 'monitoring_day', value || null )
				return value
			}
			return this.$.$mol_state_arg.value( 'monitoring_day' ) ?? this.latest_day()
		}

		private day_shift( shift: number ) {
			const date = new Date( `${ this.day() }T12:00:00` )
			date.setDate( date.getDate() + shift )
			return [
				date.getFullYear(),
				String( date.getMonth() + 1 ).padStart( 2, '0' ),
				String( date.getDate() ).padStart( 2, '0' ),
			].join( '-' )
		}

		@ $mol_action
		override day_prev( next?: Event ) {
			if( next === undefined ) return null
			this.day( this.day_shift( -1 ) )
			return next
		}

		day_next_enabled() {
			return this.day() < this.latest_day()
		}

		@ $mol_action
		override day_next( next?: Event ) {
			if( next === undefined ) return null
			if( this.day_next_enabled() ) this.day( this.day_shift( 1 ) )
			return next
		}

		@ $mol_action
		override day_latest( next?: Event ) {
			if( next === undefined ) return null
			this.day( this.latest_day() )
			return next
		}

		files() {
			return this.$.$shm_pb.admin_records_all_realtime( 'dashboard_files\n\nsort,title\nid,dashboard,title,file,last_data_day' )
		}

		dashboards() {
			return this.$.$shm_pb.admin_records_all_realtime( 'user_dashboards\n\nsort,title\nid,title' )
		}

		users() {
			return this.$.$shm_pb.admin_records_all_realtime( 'users\n\n-created\nid,email,name' )
		}

		latest_jobs() {
			const grouped = new Map< string, $shm_dashboard_admin_monitoring_record[] >()
			for( const job of this.jobs().filter( job => this.job_day( job ) === this.day() ) ) {
				const key = this.job_key( job )
				if( !key ) continue
				const jobs = grouped.get( key ) ?? []
				jobs.push( job )
				grouped.set( key, jobs )
			}

			const latest = new Map< string, $shm_dashboard_admin_monitoring_record >()
			for( const [ key, jobs ] of grouped ) {
				const last = jobs[0]
				const processed = last?.status === 'no_email'
					? jobs.find( job => Number( job.emails_found || 0 ) > 0 || Boolean( job.message_at ) )
					: null
				latest.set( key, processed ?? last )
			}
			return latest
		}

		job_task_id( job: $shm_dashboard_admin_monitoring_record ) {
			return String( Array.isArray( job.task ) ? job.task[0] : job.task || '' )
		}

		job_period( job: $shm_dashboard_admin_monitoring_record ) {
			return String( job.period || 'combined' )
		}

		job_key( job: $shm_dashboard_admin_monitoring_record ) {
			const task = this.job_task_id( job )
			return task ? `${ task }|${ this.job_period( job ) }` : ''
		}

		row_task_id( id: string ) {
			return id.split( '|' )[0]
		}

		latest_job( id: string ) {
			return this.latest_jobs().get( id ) ?? null
		}

		filtered_rows() {
			const query = this.filter().trim().toLowerCase()
			const source = [ ... this.latest_jobs().keys() ]
				.toSorted( ( left, right )=> Number( this.task_problem( right ) ) - Number( this.task_problem( left ) ) )
			if( !query ) return source
			return source.filter( id => [
				this.dashboard_title( id ),
				this.file_title( id ),
				this.client_title( id ),
				this.period_title( id ),
				this.ba_id_title( id ),
				this.state_title( id ),
				this.error_text( id ),
			].some( value => value.toLowerCase().includes( query ) ) )
		}

		task( id: string ) {
			const task = this.row_task_id( id )
			return this.tasks().find( record => record.id === task ) ?? null
		}

		task_rows() {
			return this.filtered_rows().map( id => this.Row( id ) )
		}

		empty_text() {
			return this.filtered_rows().length ? '' : `За ${ this.date_only( this.day() ) } запусков не найдено.`
		}

		enabled_count() {
			return String( this.tasks().filter( task => Boolean( task.enabled ) ).reduce( ( count, task )=> count
				+ Number( Boolean( task.ba_subscriber_daily_id || task.ba_subscriber_id ) )
				+ Number( Boolean( task.ba_subscriber_weekly_id ) )
				+ Number( Boolean( task.ba_subscriber_monthly_id ) ), 0 ) )
		}

		running_count() {
			return String( [ ...this.latest_jobs().values() ].filter( job => [ 'queued', 'running' ].includes( String( job.status ) ) ).length )
		}

		running_color() {
			return Number( this.running_count() ) ? `${ $shm_theme.active }` : `${ $mol_theme.shade }`
		}

		completed_count() {
			const terminal = new Set([ 'done', 'error', 'no_email', 'no_attachment', 'date_mismatch' ])
			return String( this.jobs().filter( job => this.job_day( job ) === this.day() && terminal.has( String( job.status ) ) ).length )
		}

		completed_color() {
			return Number( this.completed_count() ) ? `${ $shm_theme.success }` : `${ $mol_theme.shade }`
		}

		error_count() {
			return String( this.problem_task_ids().length )
		}

		error_count_color() {
			return Number( this.error_count() ) ? `${ $shm_theme.error }` : `${ $mol_theme.shade }`
		}

		outdated_count() {
			return String( [ ... this.latest_jobs().values() ].filter( job => String( job.count_status || '' ) === 'mismatch' ).length )
		}

		outdated_color() {
			return Number( this.outdated_count() ) ? `${ $shm_theme.error }` : `${ $mol_theme.shade }`
		}

		task_problem( id: string ) {
			const job = this.latest_job( id )
			return Boolean( job && ( String( job.error || '' ) || [ 'error', 'date_mismatch', 'no_email' ].includes( String( job.status || '' ) ) ) )
		}

		problem_task_ids() {
			return [ ... this.latest_jobs().keys() ].filter( id => this.task_problem( id ) )
		}

		problems_title() {
			const count = this.problem_task_ids().length
			const day = this.date_only( this.day() )
			return count ? `Проблемы за ${ day }: ${ count }` : `За ${ day } проблем нет`
		}

		problems_color() {
			return this.problem_task_ids().length ? `${ $shm_theme.error }` : `${ $shm_theme.success }`
		}

		problem_rows() {
			return this.problem_task_ids().map( id => this.Problem( id ) )
		}

		problem_title( id: string ) {
			return `${ this.dashboard_title( id ) } · ${ this.file_title( id ) } · ${ this.period_title( id ) }: ${ this.error_text( id ) }`
		}

		@ $mol_action
		override problem_open( id: string, next?: Event ) {
			if( next === undefined ) return null
			this.filter( this.file_title( id ) )
			return next
		}

		file_record( id: string ) {
			const task = this.task( id )
			return this.files().find( file => file.id === String( task?.file || '' ) ) ?? null
		}

		dashboard_title( id: string ) {
			const file = this.file_record( id )
			const dashboard = this.dashboards().find( dashboard => dashboard.id === String( file?.dashboard || '' ) )
			return String( dashboard?.title || file?.dashboard || 'Дашборд удалён' )
		}

		file_title( id: string ) {
			const task = this.task( id )
			const file = this.file_record( id )
			return String( file?.title || file?.file || task?.file || 'Файл удалён' )
		}

		client_title( id: string ) {
			const task = this.task( id )
			const user = this.users().find( user => user.id === String( task?.client || '' ) )
			return String( user?.email || user?.name || task?.client || 'Клиент удалён' )
		}

		period_title( id: string ) {
			const period = String( this.latest_job( id )?.period || 'combined' )
			return ({ daily: 'Ежедневно', weekly: 'Еженедельно', monthly: 'Ежемесячно', combined: 'Общий (старый)' } as Record< string, string >)[ period ] ?? period
		}

		ba_id_title( id: string ) {
			const task = this.task( id )
			const period = String( this.latest_job( id )?.period || 'combined' )
			if( period === 'weekly' ) return String( task?.ba_subscriber_weekly_id || '—' )
			if( period === 'monthly' ) return String( task?.ba_subscriber_monthly_id || '—' )
			return String( task?.ba_subscriber_daily_id || task?.ba_subscriber_id || '—' )
		}

		state_title( id: string ) {
			const task = this.task( id )
			const job = this.latest_job( id )
			if( !task?.enabled ) return 'Отключено'
			if( !job ) return 'Нет запуска'
			if( job?.status === 'queued' ) return 'В очереди'
			if( job?.status === 'running' ) return `Выполняется: ${ job.stage || 'запуск' }`
			if( job.status === 'date_mismatch' ) return 'Старая проверка даты'
			if( job.status === 'error' || job.error ) return 'Ошибка'
			if( job.status === 'no_email' ) return 'Новых писем нет'
			if( job.status === 'no_attachment' ) return 'Нет вложений'
			if( job.status === 'done' && Number( job.spam_found || 0 ) ) return 'Обновлено из спама'
			if( job.status === 'done' && job.count_status === 'zero' ) return 'Обновлено: 0 сообщений'
			if( job.status === 'done' && [ 'matched', 'legacy_date_only' ].includes( String( job.count_status || '' ) ) ) {
				return job.count_status === 'matched' ? `Обновлено: ${ Number( job.reported_rows || 0 ) } сообщений` : 'Обновлено без сверки'
			}
			return job.status === 'done' ? 'Обновлено' : String( job.status || 'Завершено' )
		}

		state_color( id: string ) {
			const task = this.task( id )
			const job = this.latest_job( id )
			if( !task?.enabled ) return `${ $mol_theme.shade }`
			if( !job ) return `${ $shm_theme.error }`
			if( [ 'queued', 'running' ].includes( String( job.status ) ) ) return `${ $shm_theme.active }`
			if( job.error || [ 'error', 'date_mismatch', 'no_email', 'no_attachment' ].includes( String( job.status ) ) ) return `${ $shm_theme.error }`
			if( Number( job.spam_found || 0 ) ) return `${ $shm_theme.active }`
			if( job.status === 'done' ) return `${ $shm_theme.success }`
			return `${ $mol_theme.shade }`
		}

		dates_text( id: string ) {
			const job = this.latest_job( id )
			return [
				`Письмо: ${ this.date_time( String( job?.message_at || '—' ) ) }`,
				`Отчёт по: ${ this.date_only( String( job?.expected_data_day || '—' ) ) }`,
				`Последняя запись: ${ this.date_only( String( job?.data_day || '—' ) ) }`,
				`В письме: ${ job?.count_status === 'legacy_date_only' ? 'не сохранялось' : job?.count_status && job.count_status !== 'unknown' ? Number( job.reported_rows || 0 ) : '—' }`,
				`В Excel: ${ job?.rows_received !== undefined && job?.rows_received !== null ? Number( job.rows_received ) : '—' }`,
			].join( '\n' )
		}

		date_time( value: string ) {
			if( !value || value === '—' ) return '—'
			const time = new Date( value )
			return Number.isFinite( time.getTime() ) ? time.toLocaleString( 'ru-RU', {
				day: '2-digit', month: '2-digit', year: 'numeric',
				hour: '2-digit', minute: '2-digit', second: '2-digit',
			} ) : this.date_only( value )
		}

		date_only( value: string ) {
			const match = /^(\d{4})-(\d{2})-(\d{2})/.exec( value )
			return match ? `${ match[3] }.${ match[2] }.${ match[1] }` : value
		}

		duration_ms( value: unknown ) {
			const milliseconds = Number( value || 0 )
			if( !milliseconds ) return '—'
			return `${ ( Math.round( milliseconds / 100 ) / 10 ).toLocaleString( 'ru-RU' ) } с`
		}

		duration( from: unknown, to: unknown ) {
			const start = new Date( String( from || '' ) ).getTime()
			const end = new Date( String( to || '' ) ).getTime()
			if( !Number.isFinite( start ) || !Number.isFinite( end ) || end < start ) return '—'
			const seconds = Math.round( ( end - start ) / 100 ) / 10
			return `${ seconds } с`
		}

		time_text( id: string ) {
			const job = this.latest_job( id )
			if( !job ) return 'Запусков нет'
			return [
				`Очередь: ${ this.duration( job.created, job.started_at ) }`,
				`Почта: ${ this.duration( job.mail_started_at || job.started_at, job.mail_finished_at ) }`,
				`Разбор: ${ this.duration( job.parse_started_at, job.parse_finished_at ) }`,
				`DuckDB: ${ this.duration( job.duckdb_started_at, job.duckdb_finished_at ) }`,
				`  скачивание: ${ this.duration_ms( job.duckdb_download_ms ) }`,
				`  конвертация: ${ this.duration_ms( job.duckdb_convert_ms ) }`,
				`  открытие: ${ this.duration_ms( job.duckdb_open_ms ) }`,
				`  чтение CSV: ${ this.duration_ms( job.duckdb_read_ms ) }`,
				`  добавление: ${ this.duration_ms( job.duckdb_insert_ms ) }`,
				`  теги: ${ this.duration_ms( job.duckdb_tags_ms ) }`,
				`  FTS: ${ this.duration_ms( job.duckdb_fts_ms ) }`,
				`  checkpoint: ${ this.duration_ms( job.duckdb_checkpoint_ms ) }`,
				`  загрузка: ${ this.duration_ms( job.duckdb_upload_ms ) }`,
				`Всего: ${ this.duration( job.started_at || job.created, job.finished_at ) }`,
			].join( '\n' )
		}

		error_text( id: string ) {
			const job = this.latest_job( id )
			if( job?.error ) return String( job.error )
			if( job?.status === 'no_email' ) return 'Новых писем нет'
			if( Number( job?.spam_found || 0 ) ) return `Писем из спама: ${ Number( job?.spam_found || 0 ) }`
			return '—'
		}

		error_color( id: string ) {
			if( this.task_problem( id ) ) return `${ $shm_theme.error }`
			return Number( this.latest_job( id )?.spam_found || 0 ) ? `${ $shm_theme.active }` : `${ $mol_theme.shade }`
		}
	}
}
